module.exports = __webpack_public_path__ + "static/media/58.fe161f44.jpg";